import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import Icon from "../pages/Icon.jsx";
import useLockBodyScroll from "../pages/useLockBodyScroll.js";
import logo from "../assets_optimized/logo.png";   // ✅ IMPORT LOGO

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useLockBodyScroll(open);

  const links = useMemo(
    () => [
      { label: "Home", path: "/" },
      { label: "Services", path: "/services" },
      { label: "Gallery", path: "/gallery" },
    ],
    []
  );

  const close = () => setOpen(false);

  const handleLink = (path) => (e) => {
    e.preventDefault();

    if (location.pathname === path) {
      close();
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    close();
    setTimeout(() => navigate(path), 0);
  };

  return (
    <>
      <div className="navContainer">

        {/* ✅ LEFT LOGO */}
        <Link to="/" className="navLogo">
          <img src={logo} alt="Protek Studio Logo" />
        </Link>

        {/* ✅ CENTER PILL */}
        <div className="navPillContainer">
          <div className="navPill">
            {links.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className={`navLink ${
                  location.pathname === l.path ? "active" : ""
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>

          <Link to="/contact" className="btn btnPrimary navCtaPill">
            Get in touch <Icon name="arrow" />
          </Link>
        </div>

        {/* ✅ MOBILE MENU BUTTON */}
        <button
          className="btn navMenu"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Icon name="menu" />
        </button>
      </div>

      {open && (
        <div
          className="navOverlay"
          role="dialog"
          aria-modal="true"
          onPointerDown={close}
        >
          <div className="navSheet" onPointerDown={(e) => e.stopPropagation()}>
            <div className="navSheetTop">
              <div className="navSheetTitle">Menu</div>
              <button className="btn" onClick={close} aria-label="Close menu">
                <Icon name="close" />
              </button>
            </div>

            <div className="navSheetLinks">
              {links.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`navSheetLink ${
                    location.pathname === l.path ? "active" : ""
                  }`}
                  onClick={handleLink(l.path)}
                >
                  <span>{l.label}</span>
                  <Icon name="arrow" />
                </Link>
              ))}
            </div>

            <div className="navSheetBottom">
              <div className="navMiniNote">
                Elegant boutique design studio. Creating sophisticated interiors
                for discerning clients and luxury spaces.
              </div>

              <Link to="/contact" className="btn btnPrimary" onClick={close}>
                Start a project <Icon name="arrow" />
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
